<template>
  <el-tabs class="recommend" v-model="activeName">

    <el-tab-pane label="企业简介" name="corporateProfile">
      <el-form ref="profileData" style="width:50%" :model="profileData" label-width="8rem">
        <el-form-item label="LOGO">
          <el-upload class="avatar-uploader" :http-request="uploadfile" action="" :show-file-list="false">
            <img v-if="profileData.logo" :src="profileData.logo" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input maxlength="7" show-word-limit v-model="profileData.companyName"></el-input>
        </el-form-item>
        <el-form-item label="系统名称">
          <el-input maxlength="13" show-word-limit v-model="profileData.sysName"></el-input>
        </el-form-item>
        <el-form-item label="简介内容">
          <el-input type="textarea" :rows="6" v-model="profileData.content"></el-input>
        </el-form-item>
        <el-form-item label="智慧工厂进度">
          <c-progress v-if="load" style="margin-left: 10px;" :percent="profileData.smartProgress" @percentChange="smartProgress" :width="500" :slider-width="20" />
        </el-form-item>
        <el-form-item label="工业互联网进度">
          <c-progress v-if="load" style="margin-left: 10px;" :percent="profileData.industryProgress" @percentChange="industryProgress" :width="500" :slider-width="20" />
        </el-form-item>
        <el-form-item label="智能信息化融合">
          <c-progress v-if="load" style="margin-left: 10px;" :percent="profileData.informatProgress" @percentChange="informatProgress" :width="500" :slider-width="20" />
        </el-form-item>
        <div style="text-align: right;">
          <el-button @click="save" type="primary">保 存</el-button>
        </div>
      </el-form>
    </el-tab-pane>
    <el-tab-pane label="行业地位" name="position">
      <position v-if="activeName =='position'" />
    </el-tab-pane>
    <el-tab-pane label="新闻资讯" name="information">
      <information v-if="activeName =='information'" />
    </el-tab-pane>
    <el-tab-pane label="企业文化" name="culture">
      <culture v-if="activeName =='culture'" />
    </el-tab-pane>
    <el-tab-pane label="企业形象" name="images">
      <images v-if="activeName =='images'" />
    </el-tab-pane>
    <el-tab-pane label="产品介绍" name="product">
      <product v-if="activeName =='product'" />
    </el-tab-pane>
    <el-tab-pane label="企业历程" name="course">
      <course v-if="activeName =='course'" />
    </el-tab-pane>
    <el-tab-pane label="团队介绍" name="team">
      <team v-if="activeName =='team'" />
    </el-tab-pane>
    <el-tab-pane label="企业资质" name="certification">
      <certification v-if="activeName =='certification'" />
    </el-tab-pane>
    <el-tab-pane label="获得荣誉" name="honor">
      <honor v-if="activeName =='honor'" />
    </el-tab-pane>
    <el-tab-pane label="合作伙伴" name="partner">
      <partner v-if="activeName =='partner'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import api from '@/apis/recommend/index'
import upapi from '@/apis/upload'

import CProgress from '@/components/CProgress'
import position from './position'
import information from './information'
import culture from './culture'
import images from './images'
import product from './product'
import course from './course'
import team from './team'
import certification from './certification'
import honor from './honor'
import partner from './partner'
export default {
  components: {
    CProgress,
    position,
    information,
    culture,
    images,
    product,
    course,
    team,
    certification,
    honor,
    partner,
  },
  data() {
    return {
      activeName: 'corporateProfile',
      //企业简介
      load: false,
      profileData: {
        logo: '',
        smartProgress: 0, //智慧工厂进度
        industryProgress: 0, //工业互联网进度
        informatProgress: 0, //智能化信息化融合进度
        companyName: '指尖秘码', //公司名称
        sysName: '德阳指尖秘码科技信息化系统', //系统名称
        content: '',
      },
    }
  },
  mounted() {
    api.mine().then((res) => {
      if (res.code === 10000) {
        if (res.data) {
          this.profileData = res.data
        }
      } else {
        this.$message.error(res.message)
      }
      this.load = true
    })
  },
  methods: {
    //进度条
    smartProgress(per) {
      this.profileData.smartProgress = per
    },
    industryProgress(per) {
      this.profileData.industryProgress = per
    },
    informatProgress(per) {
      this.profileData.informatProgress = per
    },
    save() {
      api.save(this.profileData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //上传图片
    uploadfile(val) {
      // console.log(val);
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.profileData.logo = res.data
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.recommend {
  width: 100%;
  display: flex;
  flex-direction: column; height: 100%; overflow-y: auto;
  
}
</style>
<style>
.recommend .avatar{ width: 10rem; border: #3570ff solid 1px;}
</style>